<template>
  <div>
    <!-- Weekdays -->

    <office-hours-day :horizontal="horizontal" name="Maandag" value="monday"
                      :days="this.days.monday !== undefined ? this.days.monday : []"></office-hours-day>
    <office-hours-day :horizontal="horizontal" name="Dinsdag" value="tuesday"
                      :days="this.days.tuesday !== undefined ? this.days.tuesday : []"></office-hours-day>
    <office-hours-day :horizontal="horizontal" name="Woensdag" value="wednesday"
                      :days="this.days.wednesday !== undefined ? this.days.wednesday : []"></office-hours-day>
    <office-hours-day :horizontal="horizontal" name="Donderdag" value="thursday"
                      :days="this.days.thursday !== undefined ? this.days.thursday : []"></office-hours-day>
    <office-hours-day :horizontal="horizontal" name="Vrijdag" value="friday"
                      :days="this.days.friday !== undefined ? this.days.friday : []"></office-hours-day>
    <office-hours-day :horizontal="horizontal" name="Zaterdag" value="saturday"
                      :days="this.days.saturday !== undefined ? this.days.saturday : []"
    ></office-hours-day>
    <office-hours-day :horizontal="horizontal" name="Zondag" value="sunday"
                      :days="this.days.sunday !== undefined ? this.days.sunday : []"
    ></office-hours-day>

    <h4>Feestdagen</h4>
    <office-hours-day v-for="(day,index) in holidayList" :horizontal="horizontal"
                      :name="day.name" :value="day.value" :dayKey="index" dayType="holiday"
                      :days="day.days" :key="day"></office-hours-day>

    <div class="day">
      <div class="form-group">

        <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}"></label>
        <div v-bind:class="{ 'col-sm-7': horizontal}">

          <!-- Holiday -->
          <a-select v-model="newDayHoliday" style="width: 120px">
            <a-select-option v-for="(name, value) in holidays" :key="value">
              {{ name }}
            </a-select-option>
          </a-select>
          <a class="btn btn-primary" @click="addHoliday">
            <i class="mdi mdi-plus"></i>
          </a>

        </div>
      </div>
    </div>

    <h4>Uitzondering</h4>

    <office-hours-day v-for="(day,index) in exceptionList" :horizontal="horizontal"
                      :name="day.name.format('D-MM-YYYY')" :value="day.name.format('D-MM-YYYY')"
                      :days="day.days"
                      :exception="true" :key="day" :dayKey="index" dayType="exception"></office-hours-day>

    <div class="day">
      <div class="form-group">

        <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}"></label>
        <div v-bind:class="{ 'col-sm-7': horizontal}">

          <!-- Exception -->
          <a-date-picker v-model="newDayName"/>
          <a class="btn btn-primary" @click="addExceptionDay">
            <i class="mdi mdi-plus"></i>
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import OfficeHourDay from "./OfficeHourDay";
import store from "../../../../../store";
import officeModule from '../store'
import {mapGetters} from "vuex";

export default {
  name: "EditOfficeHours",
  components: {
    "office-hours-day": OfficeHourDay
  },
  props: {
    horizontal: {
      type: Boolean,
      default: true
    },
    holidays: {
      type: Object,
      default: () => ({})
    },
    days: {
      type: Object,
      default: () => ({}),
      required: false
    },
    holiday_values: {
      type: [Object, Array],
      default: () => ([]),
      required: false
    },
    exception_values: {
      type: [Object, Array],
      default: () => ([]),
      required: false
    }
  },
  data() {
    return {
      newDayName: '',
      newDayHoliday: '',
      moment: moment
    }
  },
  created() {
    if (!store.hasModule('office')) {
      store.registerModule('office', officeModule)
    }
  },
  computed: {
    ...mapGetters('office', [
      'holidayList',
      'exceptionList'
    ]),
  },
  mounted() {
    Object.entries(this.holiday_values).forEach((entry) => {
      const [key, holidays] = entry;
      this.holidayList.push({name: this.holidays[key], value: key, days: holidays})
    });

    Object.entries(this.exception_values).forEach((entry) => {
      const [key, exceptions] = entry;
      this.exceptionList.push({name: moment(key, 'DD-MM-YYYY'), value: key, days: exceptions})
    });
  },
  methods: {
    addHoliday() {
      let payload = {
        'dayName': this.holidays[this.newDayHoliday],
        'newDay': this.newDayHoliday
      };
      store.dispatch('office/addHoliday', payload);
    },
    addExceptionDay() {
      store.dispatch('office/addException', this.newDayName);
    },
  }
}
</script>

<style scoped>

</style>
